import { createApp } from 'vue'
import App from './App.vue'
import 'awesome-notifications/dist/style.css'

// Asegúrate de que 'contact' esté definido globalmente o pásalo de otro modo
const contactValue = typeof contact !== 'undefined' ? contact : null

document.addEventListener('DOMContentLoaded', () => {
  const app = createApp(App)

  // Definir propiedad global como en Vue 2
  app.config.globalProperties.$contact = contactValue

  app.mount('#blog_app')
})
